"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = exports.DropdownMenuItem = exports.DropdownMenuDivider = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const clsx_1 = require("clsx");
const eventUtils_1 = require("../common/eventUtils");
const __1 = require("..");
const react_1 = require("react");
const DropdownMenuDivider = () => (0, jsx_runtime_1.jsx)("div", { className: "tk-dropdown-menu-divider" });
exports.DropdownMenuDivider = DropdownMenuDivider;
const DropdownMenuItem = (_a) => {
    var { children, className, onClick, forwardRef, loading } = _a, rest = __rest(_a, ["children", "className", "onClick", "forwardRef", "loading"]);
    const classes = (0, clsx_1.clsx)('tk-dropdown-menu__item', className, { ['tk-dropdown-menu__item--loading']: loading });
    const focusNextOption = (current, direction) => {
        const options = (Array.from(current.parentElement.getElementsByClassName('tk-dropdown-menu__item')));
        let currentOptionPosition = options.indexOf(current);
        currentOptionPosition = currentOptionPosition > -1 ? currentOptionPosition : 0;
        const nextElementPosition = (currentOptionPosition + options.length + direction) % options.length;
        options[nextElementPosition].focus();
    };
    const onKeyDownHandler = (0, react_1.useCallback)((e) => {
        switch (e.key) {
            case eventUtils_1.Keys.ARROW_DOWN:
                e.stopPropagation();
                focusNextOption(e.currentTarget, 1);
                break;
            case eventUtils_1.Keys.ARROW_UP:
                e.stopPropagation();
                focusNextOption(e.currentTarget, -1);
                break;
            case eventUtils_1.Keys.ENTER:
                if (loading) {
                    return;
                }
                e.stopPropagation();
                onClick(e);
                break;
        }
    }, [loading]);
    const onClickHandler = (0, react_1.useCallback)((event) => {
        if (loading) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [loading]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, rest, { className: classes, role: "menu-item", onClick: onClickHandler, ref: forwardRef, onKeyDown: onKeyDownHandler, tabIndex: 0, children: loading ? (0, jsx_runtime_1.jsx)(__1.Loader, { variant: "primary" }) : children })));
};
exports.DropdownMenuItem = DropdownMenuItem;
const DropdownMenu = (_a) => {
    var { children, className, show = true, onClose } = _a, rest = __rest(_a, ["children", "className", "show", "onClose"]);
    const classes = (0, clsx_1.clsx)('tk-dropdown-menu', className);
    const ref = (0, react_1.useRef)(null);
    const keyboardEventHandler = (e) => {
        e.stopPropagation();
        if (e.key === eventUtils_1.Keys.ESC && onClose) {
            onClose();
        }
    };
    const mouseEventHandler = (e) => {
        e.stopPropagation();
        if (onClose && ref && !e.composedPath().includes(ref.current)) {
            onClose();
        }
    };
    const removeListeners = (0, react_1.useCallback)(() => {
        var _a, _b;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.ownerDocument.removeEventListener('keyup', keyboardEventHandler);
        (_b = ref.current) === null || _b === void 0 ? void 0 : _b.ownerDocument.removeEventListener('click', mouseEventHandler);
    }, []);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!show) {
            removeListeners();
            return;
        }
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.ownerDocument.addEventListener('keyup', keyboardEventHandler);
        (_b = ref.current) === null || _b === void 0 ? void 0 : _b.ownerDocument.addEventListener('click', mouseEventHandler);
        return () => {
            removeListeners();
        };
    }, [show, removeListeners]);
    return show && (0, jsx_runtime_1.jsx)("div", Object.assign({}, rest, { className: classes, role: "menu", ref: ref, children: children }));
};
exports.DropdownMenu = DropdownMenu;
